<template>
    <v-dialog v-model="dialogVisible" max-width="1200">
        <v-card class="pa-5 px-8">
            <div class="d-flex justify-space-between align-center mb-5">
                <p class="font-weight-bold ma-0 text-h6">Criação de usuário:</p>

                <v-btn icon @click="dialogVisible = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>

            <v-row>
                <v-col class="py-0" cols="6">
                    <v-text-field required hide-details class="my-2" label="Nome *" v-model="name" outlined dense
                        :rules="textRules" placeholder="Nome"></v-text-field>
                </v-col>

                <v-col class="py-0" cols="6">
                    <v-text-field required :error-messages="emailErrors" hide-details="auto" class="mt-2" label="E-mail *"
                        v-model="email" @input="handleEmailInput" outlined dense :rules="textRules"
                        placeholder="E-mail">
                        <template v-slot:append>
                            <v-progress-circular v-if="loadingEmail" class="ml-2" color="primary" size="20" height="7"
                                indeterminate></v-progress-circular>

                            <v-icon color="red" v-if="emailErrors && emailErrors.length > 0">
                                mdi-close
                            </v-icon>

                            <v-icon color="success" v-if="
                                !emailErrors ||
                                (emailErrors.length === 0 && isEmailAvailable)
                            ">
                                mdi-check
                            </v-icon>
                        </template>
                    </v-text-field>
                </v-col>

                <v-col class="py-0" cols="6">
                    <v-text-field hide-details class="my-2" label="Cargo" v-model="job_description" outlined
                        dense placeholder="Executivo de vendas"></v-text-field>
                </v-col>

                <v-col class="py-0" cols="6">
                    <v-select required hide-details class="my-2" label="Setor *" :items="accessTypeIdItems"
                        placeholder="Setor" v-model="accessTypeId" outlined item-value="id" item-text="name" dense
                        :menu-props="{ width: '20px' }"></v-select>
                </v-col>
            </v-row>

            <v-row class="align-center" v-for="(phone, index) in phones" :key="index">
                <v-col class="py-0" cols="3">
                    <v-select required :items="phoneTypes" item-value="id" item-text="name" placeholder="Tipo *"
                        v-model="phone.type" outlined dense :menu-props="{ width: '20px' }" hide-details></v-select>
                </v-col>

                <v-col class="py-0" cols="3">
                    <v-autocomplete required item-text="code" item-value="code" :items="allDDIs" placeholder="DDI *"
                        v-model="phone.prefixo" outlined dense :menu-props="{ width: '20px' }"
                        hide-details></v-autocomplete>
                </v-col>

                <v-col class="py-0" cols="5">
                    <v-text-field required hide-details class="my-2" label="Telefone *" v-model="phone.number"
                        v-mask="['(##) ####-####', '(##) #####-####']" outlined dense :rules="textRules"
                        placeholder="Telefone"></v-text-field>
                </v-col>

                <v-col class="py-0 mb-2" cols="1">
                    <v-icon @click="removePhone(index)">mdi-trash-can</v-icon>
                </v-col>
            </v-row>

            <v-btn text color="primary" class="my-2" @click="addPhone">
                + Adicionar Telefone
            </v-btn>

            <v-text-field required hide-details class="my-2" label="Vínculo de atendimento *" v-model="info" outlined
                dense :rules="textRules" placeholder="Executivo para o setor financeiro, atendimento de sinal nacional..."></v-text-field>


            <v-row>
                <v-col cols="12" class="py-0 mt-4">
                    <label for="cellphone" class="font-weight-black">Associação de perfis que o usuário terá acesso <span class="field_required">
                            *
                        </span></label>

                    <v-text-field v-model="searchUserTxt" hide-details @input="handleSearchUserTxt"
                        append-icon="mdi-magnify" outlined dense
                        placeholder="Busque perfis por Nome, Razão Social ou CNPJ" class="mb-3">
                        <template v-slot:append>
                            <v-progress-circular v-if="loadingProfile" class="ml-2" color="grey" size="20" height="7"
                                indeterminate></v-progress-circular>
                        </template>
                    </v-text-field>

                    <v-row>

                        <v-col cols="8">

                            <v-data-table :headers="vehicleHeaders" :items="availableProfiles" :search="searchUserTxt"
                                item-key="id" dense height="270" fixed-header :items-per-page="-1" hide-default-footer
                                class="elevation-1 clickable-table" @click:row="addUserToSelected">
                                <template v-slot:[`item.name`]="{ item }">
                                    <div class="font-weight-medium">{{ item.name }}</div>
                                </template>

                                <template v-slot:[`item.displayName`]="{ item }">
                                    <div>{{ item.displayName }}</div>
                                </template>

                                <template v-slot:[`item.document`]="{ item }">
                                    <div class="text-center">{{ formatCNPJ(item.document) }}</div>
                                </template>

                                <template v-slot:no-data>
                                    <div class="text-center pa-4">
                                        <v-icon large color="grey">mdi-database-search</v-icon>
                                        <div class="text-h6 grey--text">Nenhum perfil encontrado</div>
                                    </div>
                                </template>
                            </v-data-table>
                        </v-col>


                        <v-col cols="4">

                            <v-data-table :headers="selectedHeaders" :items="allUsersSelected" item-key="id" dense
                                height="270" fixed-header :items-per-page="-1" hide-default-footer class="elevation-1">
                                <template v-slot:[`item.name`]="{ item }">
                                    <div class="font-weight-medium">{{ item.name }}</div>
                                </template>

                                <template v-slot:[`item.actions`]="{ item }">
                                    <v-btn small color="red" text @click="removeUserFromSelected(item.id)">
                                        <v-icon small>mdi-close</v-icon>
                                    </v-btn>
                                </template>

                                <template v-slot:no-data>
                                    <div class="text-center pa-4">
                                        <v-icon large color="grey">mdi-account-multiple-outline</v-icon>
                                        <div class="text-body-2 grey--text">Nenhum perfil selecionado</div>
                                    </div>
                                </template>
                            </v-data-table>


                        </v-col>

                    </v-row>


                    <div class="d-flex justify-space-between align-center mt-2">
                        <span class="text-caption">{{ allUsersSelected.length }} perfil(is) selecionado(s) do total de {{ filteredProfiles.length }}</span>
                        <v-btn text color="success" small @click="selectAllProfiles()" style="margin-left: 150px;">
                            <v-icon small class="mr-1">mdi-check-all</v-icon>
                            Selecionar todos
                        </v-btn>
                        <v-btn text color="primary" small @click="removeAllSelectedUsers()">
                            <v-icon small class="mr-1">mdi-delete</v-icon>
                            Limpar seleção
                        </v-btn>
                    </div>

                </v-col>
            </v-row>


            <div class="text-right mt-4">
                <v-btn @click="submitFormUser" color="green" class="white--text font-weight-bold">Criar usuário

                    <v-progress-circular class="ml-2" v-if="loadingCreateUser" color="white" size="20"
                        indeterminate></v-progress-circular>
                </v-btn>
            </div>
        </v-card>

        <v-snackbar v-model="toastCreateUserBox" :timeout="4000" color="primary" top>
            {{ textToastCreateUserBox }}
        </v-snackbar>
    </v-dialog>
</template>

<script>
import debounce from "lodash/debounce";
import { getAuth, getAuthToken } from '@/services/authService'

export default {
    name: 'AddUserDialog',

    props: {
        isAddUser: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            name: '',
            email: '',
            job_description: '',
            accessTypeId: null,
            info: '',
            phones: [{ type: "", prefixo: "+55", number: "" }],

            loadingEmail: false,
            isEmailAvailable: null,
            isEmailValid: null,
            isAutomaticPassword: true,
            loadingCreateUser: false,

            toastCreateUserBox: false,
            textToastCreateUserBox: "Usuário criado com sucesso!",

            textRules: [(v) => !!v || "Campo Obrigatório"],

            searchUserTxt: "",
            loadingProfile: false,
            allUsersSelected: [],

            vehicleHeaders: [
                {
                    text: "Nome",
                    value: "displayName",
                    sortable: true,
                    width: "40%"
                },
                {
                    text: "Razão Social",
                    value: "name",
                    sortable: true,
                    width: "30%"
                },
                {
                    text: "CNPJ",
                    value: "document",
                    sortable: true,
                    align: "center",
                    width: "30%"
                }
            ],

            selectedHeaders: [
                {
                    text: "Razão Social",
                    value: "name",
                    sortable: true,
                    width: "80%"
                },
                {
                    text: "",
                    value: "actions",
                    sortable: false,
                    align: "center",
                    width: "20%"
                }
            ],

            phoneTypes: [
                {
                    id: 8,
                    name: "Celular",
                },
                {
                    id: 2,
                    name: "Telefone Fixo",
                },
                {
                    id: 9,
                    name: "Whatsapp",
                },
            ],

            accessTypeIdItems: [
                {
                    id: 1,
                    name: "Administrativo",
                },
                {
                    id: 3,
                    name: "Comercial",
                },
                {
                    id: 4,
                    name: "Marketing",
                },
                {
                    id: 5,
                    name: "Financeiro",
                },
                {
                    id: 9,
                    name: "Criativo",
                },
                {
                    id: 10,
                    name: "OPEC",
                },
            ],

            allDDIs: [
                { code: '+55', text: '+55 (Brasil)' },
                { code: '+1', text: '+1 (EUA/Canadá)' },
                { code: '+44', text: '+44 (Reino Unido)' },
                { code: '+33', text: '+33 (França)' },
                { code: '+49', text: '+49 (Alemanha)' },
                { code: '+34', text: '+34 (Espanha)' },
                { code: '+39', text: '+39 (Itália)' },
                { code: '+54', text: '+54 (Argentina)' },
                { code: '+56', text: '+56 (Chile)' },
                { code: '+57', text: '+57 (Colômbia)' },
                { code: '+52', text: '+52 (México)' }
            ]
        }
    },

    computed: {
        dialogVisible: {
            get() {
                return this.isAddUser;
            },
            set(value) {
                this.$emit('update:isAddUser', value);
            }
        },

        emailErrors() {
            const errors = [];

            if (this.isEmailAvailable === false) {
                errors.push("E-mail já cadastrado");
            }

            if (this.isEmailValid === false) {
                errors.push("E-mail inválido");
            }

            return errors;
        },

        auth() {
            return getAuth()
        },

        filteredProfiles() {
            if (!this.auth || !this.auth.profiles) return [];

            const profiles = Object.keys(this.auth.profiles)
                .map(key => ({
                    id: key,
                    ...this.auth.profiles[key]
                }))
                .filter(profile => profile.profileTypeId === 2);

            if (!this.searchUserTxt) {
                return profiles;
            }

            const searchTerm = this.searchUserTxt.toLowerCase();
            return profiles.filter(profile =>
                (profile.displayName && profile.displayName.toLowerCase().includes(searchTerm)) ||
                (profile.document && profile.document.toLowerCase().includes(searchTerm)) ||
                (profile.name && profile.name.toLowerCase().includes(searchTerm))
            );
        },

        availableProfiles() {
            return this.filteredProfiles.filter(profile =>
                !this.allUsersSelected.some(selected => selected.id === profile.id)
            );
        }
    },

    watch: {
        isAddUser(newVal) {
            if (newVal) {
                this.cleanFormUserValues();
            }
        },


    },

    methods: {
        handleEmailInput() {
            this.debouncedCheckEmail();
        },

        debouncedCheckEmail: debounce(function () {
            this.checkEmail();
        }, 500),

        async checkEmail() {
            try {
                this.loadingEmail = true;
                this.isEmailAvailable = null;
                this.isEmailValid = null;

                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                if (!emailRegex.test(this.email)) {
                    this.loadingEmail = false;
                    this.isEmailValid = false;
                    return;
                }

                const authToken = getAuthToken();

                if (!authToken || !authToken.secureKey || !authToken.accessKey) {
                    this.loadingEmail = false;
                    return;
                }

                return await this.$axios
                    .post("assets/checker/email", {
                        input: "email",
                        value: this.email,
                    })
                    .then((data) => {
                        const statusEmail = data.data.data.available;
                        this.loadingEmail = false;
                        this.isEmailAvailable = statusEmail;
                    })
                    .catch((emailError) => {
                        this.loadingEmail = false;
                        this.isEmailValid = false;
                        throw emailError;
                    });
            } catch (error) {
                this.loadingEmail = false;
            }
        },

        cleanFormUserValues() {
            this.name = '';
            this.email = '';
            this.job_description = '';
            this.accessTypeId = null;
            this.info = '';
            this.phones = [{ type: "", prefixo: "+55", number: "" }];
            this.isEmailAvailable = null;
            this.isEmailValid = null;
            this.searchUserTxt = '';
            this.allUsersSelected = [];
        },

        async submitFormUser() {
            if (!this.name || !this.email || !this.accessTypeId || !this.info) {
                this.textToastCreateUserBox = "Por favor, preencha todos os campos obrigatórios.";
                this.toastCreateUserBox = true;
                return;
            }

            if (this.emailErrors && this.emailErrors.length > 0) {
                this.textToastCreateUserBox = "Por favor, corrija os erros do e-mail antes de continuar.";
                this.toastCreateUserBox = true;
                return;
            }

            const validPhones = this.phones.filter(phone => phone.type && phone.prefixo && phone.number);
            if (validPhones.length === 0) {
                this.textToastCreateUserBox = "Por favor, adicione pelo menos um telefone válido.";
                this.toastCreateUserBox = true;
                return;
            }

            this.loadingCreateUser = true;

            try {
                const urlCreateProfile = "publisherportal/register";
                const phonesFormatted = this.phones
                    .filter(phone => phone.type && phone.prefixo && phone.number)
                    .map((phone) => {
                        const patterToRemoveNumberDetails = /\((\d{2})\)\s*(\d{4,5})-(\d{4})/;
                        const numberFormatted = phone.number.match(patterToRemoveNumberDetails);

                        if (!numberFormatted) {
                            return null;
                        }

                        return {
                            type: phone.type,
                            ddd: numberFormatted[1],
                            ddi: phone.prefixo.slice(1),
                            number: numberFormatted[2] + numberFormatted[3],
                        };
                    })
                    .filter(phone => phone !== null);

                
                const accounts = this.allUsersSelected.map(profile => profile.profileId)

                let formattedForm = {
                    name: this.name,
                    email: this.email,
                    phones: phonesFormatted,
                    info: this.info,
                    accessTypeId: this.accessTypeId,
                    jobDescription: this.job_description,
                    attachSAMT: true,
                    accounts: accounts,
                    mv: true
                };

                const authToken = getAuthToken();
                const auth = getAuth()

                if (!authToken || !authToken.secureKey || !authToken.accessKey) {
                    this.loadingCreateUser = false;
                    this.textToastCreateUserBox = "Erro de autenticação. Faça login novamente.";
                    this.toastCreateUserBox = true;
                    return;
                }

                if (!auth || !auth.profileId) {
                    this.loadingCreateUser = false;
                    this.textToastCreateUserBox = "Erro: Perfil não encontrado. Faça login novamente.";
                    this.toastCreateUserBox = true;
                    return;
                }

                await this.$axios.post(this.$apiURL + urlCreateProfile, formattedForm,
                ).then((data) => {
                    this.loadingCreateUser = false;
                    this.dialogVisible = false;
                    this.cleanFormUserValues();
                    this.toastCreateUserBox = true;
                    this.textToastCreateUserBox = "Usuário criado e vinculado com sucesso!";

                    this.$emit('userCreated');
                });
            } catch (error) {
                this.loadingCreateUser = false;

                if (error.response && error.response.data) {
                    this.textToastCreateUserBox = `Erro: ${error.response.data.message || 'Erro interno do servidor'}`;
                } else {
                    this.textToastCreateUserBox = "Erro ao criar usuário. Tente novamente.";
                }
                this.toastCreateUserBox = true;
            }
        },



        addPhone() {
            this.phones.push({ type: "", prefixo: "+55", number: "" });
        },

        removePhone(index) {
            if (index === 0) {
                this.phones[0].type = "";
                this.phones[0].prefixo = "+55";
                this.phones[0].number = "";
            } else {
                this.phones.splice(index, 1);
            }
        },

        handleSearchUserTxt() {
            this.loadingProfile = true;
            setTimeout(() => {
                this.loadingProfile = false;
            }, 500);
        },

        removeAllSelectedUsers() {
            this.allUsersSelected = [];
        },

        selectAllProfiles() {
            this.availableProfiles.forEach(profile => {
                if (!this.isUserSelected(profile.id)) {
                    this.allUsersSelected.push(profile);
                }
            });
        },

        addUserToSelected(user) {
            if (!this.isUserSelected(user.id)) {
                this.allUsersSelected.push(user);
            }
        },

        removeUserFromSelected(userId) {
            this.allUsersSelected = this.allUsersSelected.filter(user => user.id !== userId);
        },

        isUserSelected(userId) {
            return this.allUsersSelected.some(user => user.id === userId);
        },

        formatCNPJ(cnpj) {
            if (!cnpj) return '-';

            const cleanCNPJ = cnpj.replace(/\D/g, '');

            if (cleanCNPJ.length === 14) {
                return cleanCNPJ.replace(
                    /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
                    '$1.$2.$3/$4-$5'
                );
            }

            return cnpj;
        }
    }
};
</script>

<style lang="scss" scoped>
* {
    font-family: 'Roboto', sans-serif !important;
}

.v-dialog .v-card * {
    font-family: 'Roboto', sans-serif !important;
}

.v-text-field * {
    font-family: 'Roboto', sans-serif !important;
}

.v-select * {
    font-family: 'Roboto', sans-serif !important;
}

.v-autocomplete * {
    font-family: 'Roboto', sans-serif !important;
}

.v-btn * {
    font-family: 'Roboto', sans-serif !important;
}

.v-data-table * {
    font-family: 'Roboto', sans-serif !important;
}

.v-snackbar * {
    font-family: 'Roboto', sans-serif !important;
}

p, span, div, label, input, button {
    font-family: 'Roboto', sans-serif !important;
}

.field_required {
    color: red;
    font-family: 'Roboto', sans-serif !important;
}

.clickable-table {
    ::v-deep .v-data-table__wrapper tbody tr {
        cursor: pointer;
        transition: background-color 0.2s ease;
        
        &:hover {
            background-color: rgba(25, 118, 210, 0.08) !important;
        }
        
        * {
            font-family: 'Roboto', sans-serif !important;
        }
    }
}

::v-deep .v-application {
    font-family: 'Roboto', sans-serif !important;
}

::v-deep .v-dialog {
    font-family: 'Roboto', sans-serif !important;
}

::v-deep .v-menu__content {
    font-family: 'Roboto', sans-serif !important;
}

::v-deep .v-list-item {
    font-family: 'Roboto', sans-serif !important;
}
</style>